import { useConfig } from 'core/common/hooks';
import { web2AppLinkFeature } from 'core/feature-flags/config';
import { useFeatureFlags } from 'core/feature-flags/hooks';

export function useUserW2APromoLinkFeature() {
  const { web2appLink } = useConfig();

  const featureFlags = useFeatureFlags();

  return featureFlags.getFeatureValue(web2AppLinkFeature, web2appLink);
}
